//@ts-nocheck
import pixelTag from '../../lib/gtm/pixel'
import { stepsSettings } from '../../assets/stepsStoreData/stepsSettings'
import { inputs, steps } from '../../assets/stepsStoreData/stepsData'
import { largeConversion, shortConversion } from '../../lib/gtm/convrsion'
import { getUserData } from './getUserData'
import { pixelConfig } from './pixelConfig'
import getGeoZip from './utils/getGeoZip'

interface StepsStoreConfig {
  start?: Function
  getData: Function
  nextStep?: Function
  finish?: Function
  prevCurrentStep?: Function
  changeCurrentStep?: Function
}
interface Props {
  token?: string
  lff_uid?: string
  getUser: Function
}
// export interface StepsStoreConfig {
//   stepsSettings: 
// }

interface FinishProps {
  lff_uid?: string
  finish?: Function
}

interface StartProps {
  step?: number
}

interface NextStepProps {
  pixel?: string
  utm?: { value: number, check: boolean }
  step?: number
}

interface PrevCurrentStepProps {
  step?: number
}

interface ChangeCurrentStepProps {
  step?: number
}

let conversion: null | { short: string, large: string } = null
// let pixelConfig = pixelConfig

export const stepsStoreConfig: StepsStoreConfig = {


  start: ({ step }: StartProps) => {
    setTimeout(() => {
      pixelTag(pixelConfig.pixelStart)
    }, 100)
    if (step !== null && step !== undefined) {
      changeQuertyStepParam(step + 1)
    }
  },

  getData: async ({
    token,
    getUser,
    lff_uid
  }: Props) => {
    console.log('getData')
    // const { steps, inputs, values: apiValues } = getUserData
    // const { values: apiValues } = await getUser()
    const { steps, inputs, values: apiValues } = await getUser()
    const stepsData = steps
    const inputData = inputs

    //получение конверсий
    conversion = apiValues?.conversion || null
    console.log('conversion', conversion)

    let value = null

    console.log(value)
    const lff_uid_local = lff_uid || apiValues?.lff_uid || null
    const values = apiValues?.ApiRequest || {}

    if (Object.keys(values).length) {
      values.accept = '1'
    }
    const geo_zip = getGeoZip(apiValues?.ApiRequest?.geo_zip, apiValues?.geo_zip)
    values.geo_zip = geo_zip

    console.log('getData')
    return {
      stepsSettings,
      steps: stepsData,
      inputs: inputData,
      values,
      lff_uid: lff_uid_local
    }
  },

  setShortData: ({
    utm
  }: {
    utm: { value: number, check: boolean }
  }) => {
    if (pixelConfig?.pixelShort) {
      pixelTag(pixelConfig.pixelShort)
    }
    if (utm && conversion) {
      shortConversion(utm, conversion?.short, pixelConfig?.pixelShortConversion)
    }
  },

  nextStep: ({
    pixel,
    utm,
    step,
    newStep
  }: NextStepProps) => {
    console.log('nextStep config -> ', utm, step)
    if (pixelConfig?.pixelSteps) {
      pixelTag(pixelConfig.pixelSteps[step])
    }
    if (utm && conversion) {
      shortConversion(utm, conversion?.short, pixelConfig?.pixelShortConversion)
      // pixelTag(pixelConfig.pixelShortConversion)
    }

    if (newStep !== null && newStep !== undefined) {
      changeQuertyStepParam(newStep + 1)
    }
  },

  prevCurrentStep: ({ step }: PrevCurrentStepProps) => {
    console.log('config prevCurrentStep', step)
    if (step !== null && step !== undefined) {
      changeQuertyStepParam(step + 1)
    }
  },

  changeCurrentStep: ({ step }: ChangeCurrentStepProps) => {
    console.log('config changeCurrentStep', step)
    if (step !== null && step !== undefined) {
      changeQuertyStepParam(step + 1)
    }
  },

  finish: async ({
    lff_uid,
    finish
  }: FinishProps) => {
    console.log('finish finish', lff_uid, finish)
    let data = null
    if (finish) {
      data = await finish(lff_uid)
      console.log(data)
      // if (data.utm && conversion) {
      //   shortConversion(data.utm, conversion?.short, pixelConfig?.pixelShortConversion)
      // }
      // if (data.utm && conversion) {
      //   largeConversion(data.utm, conversion?.large, pixelConfig?.pixelLargeConversion)
      //   // pixelTag(pixelConfig.pixelLargeConversion)
      // }
    }

    // if (pixelConfig?.pixelFinish) {
    //   pixelTag(pixelConfig.pixelFinish)
    // }

    const lff_uid_currect = lff_uid || localStorage.getItem('lff_uid')
    const redirectUrl = '/productApi/apiLoader/?lff_uid=' + lff_uid_currect
    console.log('redirectUrl', redirectUrl, data?.link)

    window.location.href = data?.link || 'https://creditsfast.com' + redirectUrl
  }
}

function changeQuertyStepParam(step: number) {
  const baseUrl = window.location.href
  const urlObj = new URL(baseUrl);
  console.log(urlObj)
  const params = new URLSearchParams(urlObj.search);
  console.log(params)
  if (!params.has('step')) {
    params.append('step', `${step}`);
  } else {
    const currentValue = params.get('step');
    if (currentValue !== `${step}`) {
      params.set('step', `${step}`);
    }
  }
  console.log(params)
  urlObj.search = params.toString();

  // eslint-disable-next-line no-restricted-globals
  history.pushState(null, 'null', urlObj)
}